module.exports = __webpack_public_path__ + "media/images/area/popular/ginza-12997bdb2509a57fb1364a2532f2e71e.jpg";